import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { reducer } from './state/workstep.reducer';
import { WorkstepEffects } from './state/workstep.effects';

import { WorkstepListComponent } from './components/workstep-list/workstep-list.component';
import { WorkstepShellComponent } from './containers/workstep-shell/workstep-shell.component';
import { WorkstepEditComponent } from './components/workstep-edit/workstep-edit.component';
import { WorkstepEditShellComponent } from './containers/workstep-edit-shell/workstep-edit-shell.component';

import { SortableColumnModule } from '../../sortableColumn/sortableColumn.module';

@NgModule({
  declarations: [
    WorkstepListComponent,
    WorkstepShellComponent,
    WorkstepEditComponent,
    WorkstepEditShellComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('worksteps', reducer),
    EffectsModule.forFeature([WorkstepEffects]),
    SortableColumnModule,
    RouterModule
  ],
  exports: [
    WorkstepListComponent,
    WorkstepEditComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SortableColumnModule
  ]
})

export class WorkstepModule {
  constructor() { }
}
